import React from "react";
import { Badge } from "antd";
import { useTranslation } from "react-i18next";
import { CampaignStatus } from "../data";

/** Which dot a status draws. Draft has no state of its own. */
const STATUS_BADGE: Record<CampaignStatus, "success" | "default"> = {
  Sent: "success",
  Draft: "default",
};

/**
 * A campaign's status, drawn the same way in the list and in its preview.
 *
 * The word is translated. It used to be the enum value printed straight out,
 * which read correctly in English by coincidence and left German showing
 * "Draft".
 */
export default function StatusBadge({ status }: { status: CampaignStatus }) {
  const { t } = useTranslation();

  return (
    <Badge
      status={STATUS_BADGE[status]}
      text={t(`pages.campaigns.status.${status}`)}
    />
  );
}
